import { memo } from 'react';
import TEXT from './generated/TEXT/QuickSearchNlpUpsellFooter';
import styles from './QuickSearchNlpUpsellFooter.module.css';

TEXT.DEFINE({
  /** Label for the button that shows how many AI-powered results are available */
  viewMoreAiResults: (count: number): string => `View AI Results (${count})`,
  /** Label for the button that links back to Standard Results from AI Results tab */
  viewStandardResults: (count: number): string =>
    `View Standard Results (${count})`,
});

type UpsellFooterProps = {
  count: number;
};

type QuickSearchUpsellLabelProps = {
  count: number;
  variant: 'ai' | 'standard';
};

function getQuickSearchUpsellLabel({
  count,
  variant,
}: QuickSearchUpsellLabelProps): string {
  return variant === 'ai'
    ? TEXT.viewMoreAiResults(count)
    : TEXT.viewStandardResults(count);
}

const QuickSearchNlpUpsellFooter = memo(({ count }: UpsellFooterProps) => (
  <div className={styles.footerWrapper}>
    <div className={styles.footerSurface}>
      {getQuickSearchUpsellLabel({ count, variant: 'ai' })}
    </div>
  </div>
));

QuickSearchNlpUpsellFooter.displayName = 'QuickSearchNlpUpsellFooter';

const QuickSearchStandardUpsellFooter = memo(({ count }: UpsellFooterProps) => (
  <div className={styles.footerWrapper}>
    <div className={styles.footerSurface}>
      {getQuickSearchUpsellLabel({ count, variant: 'standard' })}
    </div>
  </div>
));

QuickSearchStandardUpsellFooter.displayName = 'QuickSearchStandardUpsellFooter';

export {
  getQuickSearchUpsellLabel,
  QuickSearchNlpUpsellFooter,
  QuickSearchStandardUpsellFooter,
};
